var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOffline),expression:"showOffline"}],attrs:{"id":"app-offline"},on:{"click":_vm.hideOfflinePopup}},[_vm._v(_vm._s(_vm.trans('you_are_offline'))+" "),_c('svg',{staticClass:"icon icon-close"},[_c('use',{attrs:{"xlink:href":_vm.symbolsSvgUrl('icon-close')}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }